import moment from "moment";
import Vue from 'vue';
import ReportsService from '@/services/ReportsService';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';

function initialState() {
    return {
        PDFFileName: ''
    }
};

const state = initialState();

const mutations = {
    SET_PURCHASE_ORDER_FILE_NAME: (state, payload) => {
        state.PDFFileName = payload;
    }
};

const actions = {
    FETCH_PURCHASE_ORDER_DETAILS({ dispatch, commit, state }, payload) {

        ReportsService.GetPurchaseOrderList(payload).then(response => {
            const { data } = response;

            if (data.status) {
                commit('SET_PURCHASE_ORDER_FILE_NAME', data.Record);
            }
        })
    },
    SET_FILE_VALUE({ commit }, payload) {
        // Action to call the mutation with the payload
        commit("SET_PURCHASE_ORDER_FILE_NAME", payload);
      },
};

const getters = {
    getPurchaseOrderFileName: state => state.PDFFileName
};

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/PurchaseOrderStore.js